import { type RouteMeta } from '@bv/router';
import { useSettingsStore } from '@bv/stores/settings';
import { generateBreadcrumbs } from '@bv/utils/route/breadcrumbs/generate-breadcrumbs';
import { computed } from 'vue';

const isNewLayout = computed<boolean>(() => useSettingsStore().layoutType === 'new');

const conversationsBreadcrumbs = generateBreadcrumbs({
  label: 'GLOBAL.NAVS.conversations_trans',
  route: { name: 'conversations' },
});

const conversations_routes = [
  {
    path: '/conversations',
    name: 'conversations',
    redirect: { name: 'c-all-conversations' },
    component: () => import('./ConversationsView.vue'),
    meta: {
      canAccess: true,
      header: computed(() =>
        isNewLayout.value ? { title: 'GLOBAL.NAVS.conversations_trans' } : undefined,
      ) as RouteMeta['header'],
    },
    children: [
      {
        path: ':conversationId?',
        name: 'c-all-conversations',
        component: () => import('@/views/System/Conversations/partials/ConversationsLayout.vue'),
        meta: {
          breadcrumbs: conversationsBreadcrumbs(),
        },
      },
      {
        path: 'mentions/:conversationId?',
        name: 'c-mentions',
        component: () => import('@/views/System/Conversations/partials/ConversationsLayout.vue'),
        meta: {
          type: 'mentions',
          breadcrumbs: conversationsBreadcrumbs(),
        },
      },
      {
        path: 'unattended/:conversationId?',
        name: 'c-unattended',
        component: () => import('@/views/System/Conversations/partials/ConversationsLayout.vue'),
        meta: {
          type: 'unattended',
          breadcrumbs: conversationsBreadcrumbs(),
        },
      },
      {
        path: 'workflow/:conversationId?',
        name: 'c-workflow',
        component: () => import('@/views/System/Conversations/partials/ConversationsLayout.vue'),
        meta: {
          type: 'workflow',
          breadcrumbs: conversationsBreadcrumbs(),
        },
      },
      {
        path: 'custom-filters/:customFilterId/:conversationId?',
        name: 'c-conversations-custom-filters',
        component: () => import('@/views/System/Conversations/partials/ConversationsLayout.vue'),
        meta: {
          breadcrumbs: conversationsBreadcrumbs(),
        },
      },
      {
        path: 'channels/:channelId/:conversationId?',
        name: 'c-conversations-channels',
        component: () => import('@/views/System/Conversations/partials/ConversationsLayout.vue'),
        meta: {
          breadcrumbs: conversationsBreadcrumbs(),
        },
      },
      {
        path: 'teams/:teamId/:conversationId?',
        name: 'c-conversations-teams',
        component: () => import('@/views/System/Conversations/partials/ConversationsLayout.vue'),
        meta: {
          breadcrumbs: conversationsBreadcrumbs(),
        },
      },
      {
        path: 'tags/:tagId/:conversationId?',
        name: 'c-conversations-tags',
        component: () => import('@/views/System/Conversations/partials/ConversationsLayout.vue'),
        meta: {
          breadcrumbs: conversationsBreadcrumbs(),
        },
      },
      {
        path: 'calls/:contactId?',
        name: 'c-conversations-calls',
        component: () => import('@/views/System/Conversations/partials/ConversationsLayout.vue'),
        meta: {
          breadcrumbs: conversationsBreadcrumbs(),
        },
      },
    ],
  },
];

export default conversations_routes;
